import DiscussionItem from 'shared/components/discussion_item';
import Page from 'shared/components/page';
import UrlUtils from 'shared/url_utils';

const adminDiscussionView = require('templates/admin_discussion.jst.jade')

export default class AdminDiscussionItem extends DiscussionItem {
  static render(){
    this.resource.muteUrl = UrlUtils.urlJoin('/live', Page.id(), 'mute_user', '?user_id=' + this.resource.user.id);
    this.resource.muteAllUrl = UrlUtils.urlJoin('/live', Page.id(), 'mute_user', '?user_id=' + this.resource.user.id + '?mute_all=true');
    this.html = $(adminDiscussionView({ comment: this.resource }));
  }
}
